const errorPrefix = 'address.validation.error.';

export const MISSING_UNIT_NUMBER = 'MISSING_UNIT_NUMBER';
// existing errors from server address validation
export const VALID_GEO_CODE = 'VALID_GEO_CODE';
export const OFAC_CODE = 'OFAC_CODE';
export const COUNTRY_CODE = 'COUNTRY_CODE';
export const T1_CONTENT_VALIDATION = 'T1_CONTENT_VALIDATION';
export const DUPLICATE_ADDRESS = 'DUPLICATE_ADDRESS';
export const STREET_DIGIT = 'STREET_DIGIT';
export const REVERSE_GEOCODE_COUNTRY = 'REVERSE_GEOCODE_COUNTRY';
export const POSTAL_CODE = 'POSTAL_CODE';
export const DEFAULT = 'DEFAULT';
// client side errors
export const NOT_EMPTY_VALIDATION = 'validation.error.notEmpty';
export const MAX_LENGTH_VALIDATION = 'validation.error.lengthAtMost';
export const MIN_LENGTH_VALIDATION = 'validation.error.lengthAtLeast';
export const POSTAL_CODE_VALIDATION = 'validation.error.postalCode';
export const CS_DEFAULT = 'CS_DEFAULT';
export const INVALID_UNIT_NUMBER = 'INVALID_UNIT_NUMBER';

// mapped error with their information
export const ERROR_INFORMATION = {
    [MISSING_UNIT_NUMBER]: {
        error_description: 'User needs to input unit number or is not an acceptable one',
        error_name: 'MISSiNG_UNIT_NUMBER',
        error_translation: 'Vrbo.lyp.manualLocation.validation.error.notEmpty.unit',
        error_translation_2: 'address.validation.error.invalid.unitNumber'
    },
    [VALID_GEO_CODE]: {
        error_translation: `${errorPrefix}valid.geoCoordinates`,
        error_description: 'Geoservice failed providng a correct lat lng for the location given',
        error_name: 'LAT_LONG_NULL'
    },
    [OFAC_CODE]: {
        error_translation: `${errorPrefix}ofac.filter`,
        error_description: 'Prohibited region to onboard property',
        error_name: 'PROHIBITED_REGION'
    },
    [COUNTRY_CODE]: {
        error_translation: `${errorPrefix}valid.countrycode`,
        error_description: 'Missing country code',
        error_name: 'MISSING_COUNTRY'
    },
    [T1_CONTENT_VALIDATION]: {
        error_translation: `${errorPrefix}valid.address.content`,
        error_description: 'Require them to enter street address, city and post code. This error occurs when any one of these is missing',
        error_name: 'MISSING_STREET_ADDRESS_CITY_PC'
    },
    [DUPLICATE_ADDRESS]: {
        error_translation: `${errorPrefix}duplicate.information`,
        error_description: 'Duplicate information in different fields',
        error_name: 'DUPLICATE_INFORMATION'
    },
    [STREET_DIGIT]: {
        error_translation: `${errorPrefix}streetdigit`,
        error_description: 'fails to include a numeric character in the street number input field',
        error_name: 'NO_STREET_NUMBER'
    },
    [REVERSE_GEOCODE_COUNTRY]: {
        error_translation: `${errorPrefix}reverse.postalCode.city`,
        error_description: 'Lat, long from pin placement on map does not match the country they provided',
        error_name: 'PIN_MAP_COUNTRY'
    },
    [POSTAL_CODE]: {
        error_translation: `${errorPrefix}reverse.postalCode.city`,
        error_description: 'User has located the pin in the map too far away',
        error_name: 'PIN_MAP'
    },
    [DEFAULT]: {
        error_translation: `${errorPrefix}default`,
        error_description: 'Geoservice failed providng a correct lat lng for the location given',
        error_name: 'LAT_LONG_NULL'
    },
    // client side errors only need description and name
    [NOT_EMPTY_VALIDATION]: {
        error_description: 'NOT_EMPTY_VALIDATION',
        error_name: 'NOT_EMPTY_VALIDATION'
    },
    [MAX_LENGTH_VALIDATION]: {
        error_description: 'MAX_LENGTH_VALIDATION',
        error_name: 'MAX_LENGTH_VALIDATION'
    },
    [MIN_LENGTH_VALIDATION]: {
        error_description: 'MIN_LENGTH_VALIDATION',
        error_name: 'MIN_LENGTH_VALIDATION'
    },
    [MIN_LENGTH_VALIDATION]: {
        error_description: 'MIN_LENGTH_VALIDATION',
        error_name: 'MIN_LENGTH_VALIDATION'
    },
    [POSTAL_CODE_VALIDATION]: {
        error_description: 'POSTAL_CODE_VALIDATION',
        error_name: 'POSTAL_CODE_VALIDATION'
    },
    [CS_DEFAULT]: {
        error_description: 'default',
        error_name: 'default'
    },
    [INVALID_UNIT_NUMBER]: {
        error_name: 'INVALID_UNIT_NUMBER',
        error_description: 'User has confirmed the unit number is valid'
    }
};

export const getErrorInfoClient = (key) => {
    if (ERROR_INFORMATION[key]) return ERROR_INFORMATION[key];
    return ERROR_INFORMATION.CS_DEFAULT;
};

// raw error messages returned by server address validation (LYPS/PAI)
export const VALID_GEO_COORDINATES_MESSAGE = 'Valid Geo Coordinates';
export const OFAC_FILTER_MESSAGE = 'OFAC Filter';
export const VALID_COUNTRY_CODE_MESSAGE = 'Valid Country Code';
export const TIER_ONE_ADDRESS_CONTENT_VALIDATION_MESSAGE = 'Tier One Address Content Validation';
export const DUPLICATE_ADDRESS_CONTENT_MESSAGE = 'Duplicate Address Content';
export const STREET_DIGIT_MESSAGE = 'Street Digit';
export const REVERSE_GEOCODING_COUNTRY_MESSAGE = 'Reverse Geocoding Country';
export const REVERSE_GEOCODING_POSTAL_CODE_MESSAGE = 'Reverse Geocoding Postal Code';
export const REVERSE_GEOCODING_CITY_MESSAGE = 'Reverse Geocoding City';
export const SECONDARY_REVERSE_GEOCODING_POSTAL_CODE_MESSAGE = 'Secondary Reverse Geocoding Postal Code';
export const SECONDARY_REVERSE_GEOCODING_CITY_MESSAGE = 'Secondary Reverse Geocoding City';

const DEFAULT_ERROR_KEY = {
    location: 'generalState',
    code: DEFAULT
};

export const LAT_LONG_ERROR_KEY_MAP = {
    [VALID_GEO_COORDINATES_MESSAGE]: { location: 'generalState', code: VALID_GEO_CODE },
    [OFAC_FILTER_MESSAGE]: { location: 'generalState', code: OFAC_CODE },
    [VALID_COUNTRY_CODE_MESSAGE]: { location: 'country', code: COUNTRY_CODE },
    [TIER_ONE_ADDRESS_CONTENT_VALIDATION_MESSAGE]: { location: 'address1', code: T1_CONTENT_VALIDATION },
    [DUPLICATE_ADDRESS_CONTENT_MESSAGE]: { location: 'generalState', code: DUPLICATE_ADDRESS },
    [STREET_DIGIT_MESSAGE]: { location: 'address1', code: STREET_DIGIT },
    [REVERSE_GEOCODING_COUNTRY_MESSAGE]: { location: 'pinMap', code: REVERSE_GEOCODE_COUNTRY },
    [REVERSE_GEOCODING_POSTAL_CODE_MESSAGE]: { location: 'pinMap', code: POSTAL_CODE },
    [REVERSE_GEOCODING_CITY_MESSAGE]: { location: 'pinMap', code: POSTAL_CODE },
    [SECONDARY_REVERSE_GEOCODING_POSTAL_CODE_MESSAGE]: { location: 'pinMap', code: POSTAL_CODE },
    [SECONDARY_REVERSE_GEOCODING_CITY_MESSAGE]: { location: 'pinMap', code: POSTAL_CODE }
};

// only exact string messages map to a key: a non-string would be coerced by the
// property lookup (e.g. ['OFAC Filter'] -> 'OFAC Filter'), and hasOwnProperty keeps
// inherited Object.prototype names (e.g. 'constructor') from matching
const getLatLongErrorKey = (errCode) => (
    typeof errCode === 'string' && Object.prototype.hasOwnProperty.call(LAT_LONG_ERROR_KEY_MAP, errCode)
        ? LAT_LONG_ERROR_KEY_MAP[errCode]
        : DEFAULT_ERROR_KEY
);

export default getLatLongErrorKey;
